export const getCurrentTime = () => ({
  _currentYear: (new Date()).getFullYear(),
  _currentMonth: `${new Date().getMonth() + 1}`.padStart(2, '0'),
  _lastDay: `${(new Date((new Date()).getFullYear(), new Date().getMonth() + 1, 0)).getDate()}`.padStart(2, '0')
})

export const defaultCriticalVideoDuration = 20
export const videoSeekSeconds = 7
